// extracted by mini-css-extract-plugin
export default {"component":"na4sL"};